import { MAX_PIN_LENGTH } from '@/consts';
import { encryptPassword } from '@/core/domain/usecases/passwordUsecase';
import { tryJoin } from '@/core/presenter/controller/JoinController';
import { showAlertPopup, showConfirmPopup } from '@/core/presenter/controller/PopupController';
import { RouterPath } from '@/routes/RouterPath';
import { useStores } from '@/stores';
import { cleanString } from '@/utils';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useJoinPinSettingView() {
  const { userStore, presentationStore } = useStores();
  const [pin, setPin] = useState<string>('');
  const [checkPin, setCheckPin] = useState<string>('');
  const [isCheckView, setIsCheckView] = useState<boolean>(false);
  const [isPinCheckFailed, setIsPinCheckFailed] = useState<boolean>(false);
  const navigate = useNavigate();

  /** 숫자 버튼 클릭 이벤트 */
  const onClickNumberBtn = useCallback(
    async (number: string) => {
      if (isCheckView) {
        if ((checkPin.length || 0) < MAX_PIN_LENGTH) {
          const newCheckPin = checkPin + number;
          setCheckPin(newCheckPin);

          if (newCheckPin.length === MAX_PIN_LENGTH) {
            if (newCheckPin === userStore.pin) {
              const encryptedPassword = await encryptPassword(presentationStore.phoneNumber, userStore.password ?? '');
              const encryptedPin = await encryptPassword(presentationStore.phoneNumber, userStore.pin ?? '');
              const isSuccess = await tryJoin({
                countryNumber: cleanString(userStore.country ?? ''),
                phone: userStore.phone ?? '',
                name: userStore.name ?? '',
                password: encryptedPassword,
                pin: encryptedPin,
              });
              if (isSuccess.succed) {
                const isOK = await showConfirmPopup('회원가입이 완료되었습니다.', true);

                if (isOK) navigate(RouterPath.LOGIN);
              } else {
                const isOK = await showAlertPopup('회원가입에 실패하였습니다.', true, false);
                if (isOK) navigate(RouterPath.LOGIN);
              }
            } else {
              setIsPinCheckFailed(true);
              setCheckPin('');
            }
          }
        }
      } else {
        if ((pin.length || 0) < MAX_PIN_LENGTH) {
          const newPin = pin + number;
          setPin(newPin);
          userStore.setPin(newPin);

          if (newPin.length === MAX_PIN_LENGTH) {
            setIsCheckView(true);
            setCheckPin('');
          }
        }
      }
    },
    [isCheckView, checkPin, userStore, presentationStore.phoneNumber, pin, navigate],
  );

  /** 삭제 버튼 클릭 이벤트 */
  const OnClickDeleteBtn = useCallback(() => {
    if (isCheckView) {
      setCheckPin(checkPin.slice(0, -1));
    } else {
      setPin(pin.slice(0, -1));
    }
  }, [pin, checkPin, isCheckView]);

  /** 전체 삭제 버튼 클릭 이벤트 */
  const onClickAllClearBtn = useCallback(() => {
    if (isCheckView) {
      setCheckPin('');
    } else {
      setPin('');
    }
  }, [isCheckView]);

  return {
    pin,
    checkPin,
    isCheckView,
    isPinCheckFailed,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
  };
}
